module.exports = __webpack_public_path__ + "img/16.05da70be.png";